const addressHint = 'Вводите адрес полностью в этой строке, пользуясь всплывающими подсказками. При необходимости можно внести уточнения в полях ниже.';
const fiasHint = 'Заполнить в случае, если адрес отсутствует в справочнике ФИАС';

export const addressComponent = {
	hint: addressHint,
	raw: fiasHint,
};

export const uploadDocument = {
	hint: 'Рекомендуем прикладывать файлы формата PDF в монохромном режиме с разрешением 300 dpi в масштабе 1:1',
}

export const attachDocumentMultiple = {
	upload: uploadDocument,
}

export default {
	addressComponent,
	attachDocumentMultiple,
	uploadDocument,
};